import React, {Component} from 'react';

import Search from "../core/Search";
import Dialog from "../util/Dialog";
import LabelDialog from "./LabelDialog";

class Labels extends Component {

    constructor(props) {
        super(props);

        this.state = {
            labelId: null
        }

        this.externalCall = this.externalCall.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
    }

    externalCall(method) {
        let id = method.split("-")[1];
        method = method.split("-")[0];
        if (method === "labelForm") {
            this.setState({labelId: id});
            this.setState({method: method});
        }
    }

    closeDialog(e, validMessage, errorMessage) {
        document.location = "/admin/labels";
    }

    render() {
        return (
            <React.Fragment>
                <Search
                    initData={{DATAGRID_SCREEN_ID: 105}}
                    externalCall={this.externalCall} />

                {!!this.state.method &&
                    <Dialog close={this.closeDialog}>
                        <LabelDialog
                            closeDialog={this.closeDialog}
                            labelId={this.state.labelId}/>
                    </Dialog>
                }
            </React.Fragment>
        );
    }
}

export default Labels;
